// The regulatory ecosystem as Effect Schema; it accepts exactly what the
// `@finnest/core/schemas` Zod enum accepts, which stays frozen until its last
// Zod-composing importer moves.
import { Schema } from 'effect';
import { ECOSYSTEMS } from './members.ts';

export const Ecosystem = Schema.Literals(ECOSYSTEMS);
export type Ecosystem = typeof Ecosystem.Type;
